import {texture} from "p3";
import definitions from "../../../definitions";
import NPC from "./NPC";

export default class NPCQueenKristine extends NPC {
    constructor() {
        super(definitions.NPC_ID.QUEEN_KRISTINE);

        this.collisionRadius = 24;
        this.collisionOffsetX = 1;
        this.collisionOffsetY = -34;
    }

    init() {
        super.init();

        this.addViewWithTexture(texture("char_queen_kristine_idle_00"));

        this.addShadow(definitions.SHADOW_SIZE.LARGE, 0.8, new PIXI.Point(1, -17));
        this.animateIdle(0.8);
    }

    onViewAdded() {
        super.onViewAdded();

        this.status.x += 6;
    }
}